import React, { useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook, FaApple } from "react-icons/fa";
import { IoMdEye } from "react-icons/io";
import { IoMdEyeOff } from "react-icons/io";
import ResetPassword from "./ResetPassword";

const SigninPage = ({ onSigninSuccess, onSignupClick }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);

  const validateForm = () => {
    let valid = true;
    let emailError = "";
    let passwordError = "";

    if (!email) {
      emailError = "Email is required.";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      emailError = "Please enter a valid email address.";
      valid = false;
    }

    if (!password) {
      passwordError = "Password is required.";
      valid = false;
    }

    setErrors({ email: emailError, password: passwordError });
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const userInfo = {
        email,
        password,
      };
      onSigninSuccess(userInfo);
    }
  };

  if (showResetPassword) {
    return <ResetPassword />;
  }

  return (
    <div className="h-full w-full max-w-sm mx-auto">
      <div className="bg-white rounded-3xl h-full p-9 pt-[10rem]">
        <h1 className="font-young-serif text-[30px] font-normal text-[#1E0A1E] leading-8 text-center pb-11">
          Sign in to Famjam
        </h1>
        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              className="w-full border border-gray-300 text-[#6B7280] font-space-grotesk text-[16px] rounded-full px-5 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            {errors.email && (
              <p className="text-red-500 font-space-grotesk text-sm mt-1">
                {errors.email}
              </p>
            )}
          </div>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="w-full border border-gray-300 text-[#6B7280] font-space-grotesk text-[16px] rounded-full px-5 py-2 pr-12 focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <p
              className="text-[#929292] text-[12px] font-space-grotesk mt-1 cursor-pointer"
              onClick={() => setShowResetPassword(true)}
            >
              Forgotten email and password?
            </p>
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-4 top-[35%] transform -translate-y-1/2 text-gray-500"
            >
              {showPassword ? (
                <IoMdEyeOff className="h-5 w-5" />
              ) : (
                <IoMdEye className="h-5 w-5" />
              )}
            </button>
            {errors.password && (
              <p className="text-red-500 font-space-grotesk text-sm mt-1">
                {errors.password}
              </p>
            )}
          </div>
          <button
            type="submit"
            className="bg-[#B08CFF] font-space-grotesk w-full text-black text-lg font-bold py-2 rounded-full hover:bg-purple-600 transition duration-200"
          >
            Sign in
          </button>
        </form>
        <div className="flex items-center my-6">
          <span className="flex-grow border-t border-gray-300"></span>
          <span className="mx-4 text-[14px] text-[#929292] font-normal font-space-grotesk">
            OR
          </span>
          <span className="flex-grow border-t border-gray-300"></span>
        </div>
        <div className="space-y-4">
          <button className="font-space-grotesk w-full flex items-center justify-center bg-[#EEEEEE] border py-2 rounded-full text-[#1E0A1E] text-[16px] font-medium hover:bg-gray-200">
            <FaApple className="h-5 w-5 mr-2" />
            Continue with Apple
          </button>
          <button className="font-space-grotesk w-full flex items-center justify-center bg-[#EEEEEE] border py-2 rounded-full text-[#1E0A1E] text-[16px] font-medium hover:bg-gray-200">
            <FcGoogle className="h-5 w-5 mr-2" />
            Continue with Google
          </button>
          <button className="font-space-grotesk w-full flex items-center justify-center bg-[#EEEEEE] border py-2 rounded-full text-[#1E0A1E] text-[16px] font-medium hover:bg-gray-200">
            <FaFacebook className="h-5 w-5 mr-2 text-[#1877F2]" />
            Continue with Facebook
          </button>
        </div>
        <p className="font-space-grotesk text-center text-16px font-medium text-[#1E0A1E] mt-12">
          No account?{" "}
          <button
            onClick={onSignupClick}
            className="text-[#B08CFF] font-space-grotesk text-[16px] font-bold"
          >
            Register
          </button>
        </p>
      </div>
    </div>
  );
};

export default SigninPage;
